<template>
  <div class="application-modal">
    <div class="application-modal__window">

      <div class="small-modal">
        <div class="small-modal__title">
          {{title}}
        </div>

        <slot />

        <div class="application-modal__actions small-modal__cta">
          <slot
            name="actions"
            classAction="application-modal__action"
          />
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        default: '',
      },
    },
  }
</script>

<style lang="scss">
  @import "~styles/definitions";

  .application-modal {
    position: fixed;
    z-index: 200;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba($color-black, 0.75);
    padding: 0 r(8);
  }

  .application-modal__window {
    @include card;
    max-width: r(480);
    background-color: $color-white;
    margin: r(32) auto;
  }

  .application-modal__actions {
    flex-wrap: wrap;
    margin-left: r(-12);
    margin-right: r(-12);
    margin-bottom: r(-24);
  }

  .application-modal__action {
    margin: 0 r(12) r(24);
  }
</style>
